module.exports = __webpack_public_path__ + "img/jbts.9c7011eb.png";